export default {

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/getters.js